import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_PORTADORES = "getPortadores";
export const GET_PORTADORES_LISTA = "getPortadoresLista";

// mutation types
export const SET_PORTADORES = "setPortadores";

const state = {
  portadores: []
};

const getters = {
  portadores(state) {
    return state.portadores;
  }
};

const actions = {
  [GET_PORTADORES](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get("portadores").then(({ data }) => {
          context.commit(SET_PORTADORES, data);
          resolve(data);
        });
      }
    });
  },
  [GET_PORTADORES_LISTA](context, filtros) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("portadoresLista", filtros).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

const mutations = {
  [SET_PORTADORES](state, portadores) {
    state.portadores = portadores;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
